// components/common/ListHeader.jsx
import React from 'react';
import { InputGroup, Form, Dropdown, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import '../../styles/components/ListHeader.css';
const ListHeader = ({
  title,
  searchQuery,
  onSearch,
  sortType,
  onSort,
  onRefresh,
  isLoading,
  searchPlaceholder = "Search...",
  sortOptions = [
    { id: 'nameAsc', label: 'Sort by Name (A-Z)' },
    { id: 'nameDesc', label: 'Sort by Name (Z-A)' },
    { id: 'dateAsc', label: 'Sort by Date (Oldest)' },
    { id: 'dateDesc', label: 'Sort by Date (Newest)' }
  ]
}) => {
  // Get sort button text based on current sort type
  const getSortButtonText = () => {
    const selectedSort = sortOptions.find(option => option.id === sortType);
    if (selectedSort) {
      const labelParts = selectedSort.label.split("Sort by ");
      return labelParts.length > 1 ? labelParts[1] : selectedSort.label;
    }
    return 'Sort: None';
  };

  return (
    <div className="list-header">
      <div className="list-header-content">
        <div className="list-header-title">
          <h2>{title}</h2>
        </div>

        <div className="list-header-search">
          <InputGroup>
            <InputGroup.Text className="search-icon">
              <i className="fas fa-search"></i>
            </InputGroup.Text>
            <Form.Control
              id={`search${title.replace(/\s+/g, '')}`}
              placeholder={searchPlaceholder}
              value={searchQuery}
              onChange={onSearch}
              className="search-input"
            />
            <InputGroup.Text
              className={`search-clear ${searchQuery ? 'has-content' : ''}`}
              onClick={() => onSearch({ target: { value: '' } })}
              style={{ cursor: 'pointer' }}
              title="Clear search"
            >
              <i className="fas fa-times"></i>
            </InputGroup.Text>
          </InputGroup>
        </div>

        <div className="list-header-actions">
          <Dropdown className="sort-dropdown" drop="down">
            <Dropdown.Toggle
              id="sortButton"
              variant="outline-light"
              className="sort-button"
            >
              <i className="fas fa-sort mr-2"></i>
              <span className="sort-text">{getSortButtonText()}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="sort-menu">
              {sortOptions.map(option => (
                <Dropdown.Item
                  key={option.id}
                  id={option.id}
                  onClick={() => onSort(option.id)}
                  active={sortType === option.id}
                >
                  {option.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <Button
            variant="link"
            className={`refresh-button ${isLoading ? 'spin' : ''}`}
            onClick={onRefresh}
            disabled={isLoading}
            title="Refresh"
          >
            <i className="fas fa-sync-alt"></i>
          </Button>
        </div>
      </div>
    </div>
  );
};

ListHeader.propTypes = {
  title: PropTypes.string.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  sortType: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  searchPlaceholder: PropTypes.string,
  sortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  )
};

export default ListHeader;